import styled from "styled-components";

export const Form = styled.form`
  width: 100%;
`;
